import { Link } from 'react-router-dom';

export default function BannerSection() {
  return (
    <section className="banner-section" id="banners">
      <p className="slbl">الألعاب المميزة</p>
      <h2 className="stitle" style={{ marginBottom: '2.5rem' }}>اختار لعبتك <em>الآن</em></h2>

      <div className="banner-layout">
        {/* Main Banner */}
        <div className="main-banner" style={{ background: '#0a0a12' }}>
          <div className="mb-bg" style={{ background: 'linear-gradient(135deg,#0e1420,#1a1850,#2d1a6e)' }}>
            <div style={{ fontSize: '6rem', opacity: .6, filter: 'drop-shadow(0 0 30px rgba(150,80,255,.5))' }}>⚔️🗡️🥷</div>
          </div>
          <div className="mb-overlay" style={{ background: 'linear-gradient(135deg,rgba(60,30,140,.6) 0%,rgba(0,0,0,.3) 60%,rgba(0,0,0,.7) 100%)' }}></div>
          <div className="mb-content">
            <span className="mb-tag">🔥 الأكثر لعباً</span>
            <h3 className="mb-title">ألعاب الأكشن والقتال</h3>
            <p className="mb-sub">محارب النينجا، صائد الزومبي، قتال الظل — إختار بطلك!</p>
            <Link to="/subscribe" className="mb-btn">العب الآن →</Link>
          </div>
        </div>

        {/* Side Banners */}
        <div className="side-banners">
          <div className="side-banner" style={{ background: 'linear-gradient(135deg,#001a00,#004d15)' }}>
            <div className="sb-bg">⚽🏀🎾</div>
            <div className="sb-overlay"></div>
            <div className="sb-content">
              <div className="sb-tag">رياضة</div>
              <div className="sb-title">ألعاب الرياضة</div>
              <div className="sb-count">كرة، سلة، تنس وأكثر</div>
            </div>
          </div>

          <div className="side-banner" style={{ background: 'linear-gradient(135deg,#1a0f00,#4d3000)' }}>
            <div className="sb-bg">🍬🧩🔢</div>
            <div className="sb-overlay"></div>
            <div className="sb-content">
              <div className="sb-tag">بازل وذكاء</div>
              <div className="sb-title">ألعاب التفكير</div>
              <div className="sb-count">سودوكو، مطابقة، بازل</div>
            </div>
          </div>

          <div className="side-banner" style={{ background: 'linear-gradient(135deg,#001520,#003d5c)' }}>
            <div className="sb-bg">🏎️🏍️✈️</div>
            <div className="sb-overlay"></div>
            <div className="sb-content">
              <div className="sb-tag">سباق</div>
              <div className="sb-title">ألعاب السباق</div>
              <div className="sb-count">سيارات، دراجات، طائرات</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
